// extracted by mini-css-extract-plugin
module.exports = {"popover_class":"SavedSearchPopup_popover_class__9u2E8","mainBox":"SavedSearchPopup_mainBox__2CKNz"};